import { DateTime } from 'luxon';

interface OpeningTimeSlotData {
  fromHour: number;
  fromMinute: number;
  toHour: number;
  toMinute: number;
}

export class OpeningTimeSlot {
  private readonly fromHour: number;
  private readonly fromMinute: number;
  private readonly toHour: number;
  private readonly toMinute: number;

  constructor(data: OpeningTimeSlotData) {
    this.fromHour = data.fromHour;
    this.fromMinute = data.fromMinute;
    this.toHour = data.toHour;
    this.toMinute = data.toMinute;
  }

  get formattedTimeSlot(): string {
    const formattedStartTime = this.startTime.toFormat('HH:mm');
    const formattedEndTime = this.endTime.toFormat('HH:mm');
    return `${formattedStartTime} - ${formattedEndTime}`;
  }

  get startTime(): DateTime {
    return DateTime.now()
      .set({
        hour: this.fromHour,
        minute: this.fromMinute,
        second: 0,
        millisecond: 0
      });
  }

  get endTime(): DateTime {
    return DateTime.now()
      .set({
        hour: this.toHour,
        minute: this.toMinute,
        second: 0,
        millisecond: 0
      });
  }

  static fromJson(json: Record<string, any>): OpeningTimeSlot {
    return new OpeningTimeSlot({
      fromHour: json.fromH,
      fromMinute: json.fromM,
      toHour: json.toH,
      toMinute: json.toM,
    });
  }

  toJson(): Record<string, number> {
    return {
      fromH: this.fromHour,
      fromM: this.fromMinute,
      toH: this.toHour,
      toM: this.toMinute,
    };
  }
}
